module.exports = __webpack_public_path__ + "static/media/socket_thimble.43197a7e.webp";